import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListConfig, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';

@Component({
  selector: 'app-modal-review-group-create',
  templateUrl: './modal-review-group-create.component.html',
  styles: []
})
export class ModalReviewGroupCreateComponent extends ExcTranslation implements OnInit {

  candidates: any[] = [];
  listConfigDisplay: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  selectedAudits: any[] = [];
  step = 1;
  headerAudit: number = null;
  selectionForHeader: any[] = [];
  manualMode = false;
  groupHeader = '';
  groupText = '';
  listConfigContent: ExcListConfig = new ExcListConfig();
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService, private excRest: ExcRestService) {
    super();
    const _self = this;
    _self.listConfigDisplay.showHeader = false;
    _self.listConfigDisplay.selectionMode = 'single';
    _self.listConfigDisplay.OnFocus = (focusItem, event?) => {
      _self.headerAudit = focusItem;
    };
    _self.listConfigContent.showHeader = false;
    _self.listConfigContent.selectionMode =  'multi';
    // _self.listConfigContent.OnRefresh = (event?) => { _self.initialLoad(); };
    // _self.listConfigContent.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    // _self.listConfigContent.OnSearch = function (searchValue) {
    //   _self.searchValue = searchValue || '';
    //   _self.initialLoad();
    // };
    // _self.listconfig.OnPageChanged = (pageNo) => {
    //   _self.listconfig.paging.pagingPage = pageNo;
    //   _self.initialLoad();
    // };
    // _self.listconfig.OnRefresh = () => {
    //   _self.initialLoad();
    // };
    _self.listConfigContent.OnSelectionChanged = (selectedItems: any) => {
      _self.selectedAudits = [...selectedItems];
    };
  }

  ngOnInit() {
      if (this.overlayConfig.data.IsWizardMode === true) {
        this.step = 1;
      } else {
        this.selectedAudits = this.overlayConfig.data.PossibleAudits;
        this.step = 2;
      }
  }
  getAvatarClass(data) {
    return data.AuditType === 16
      ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
  nextStep() {
    const _self = this;
    if (this.overlayConfig.data.IsWizardMode === true) {
      if (this.step === 1) {
        this.step = 2;
        return;
      }
    }
   _self.overlayRef.close({proceed: true, Audits: _self.selectedAudits
                                  , AuditLead: (_self.manualMode === false ? _self.headerAudit['AuditID'] : null)
                                  , GroupHeader: (_self.manualMode === false ? null : _self.groupHeader)
                                  , GroupText: (_self.manualMode === false ? null : _self.groupText) });
  }
  getBackButtonText() {
    if (this.overlayConfig.data.IsWizardMode === true) {
      if (this.step === 1) {
        return this.getGlobal('Cancel');
      } else {
        return this.getGlobal('Back');
      }
    } else {
      return this.getGlobal('Cancel');
    }
  }
  getNextButtonText() {
    if (this.overlayConfig.data.IsWizardMode === true) {
      if (this.step === 1) {
        return this.getGlobal('Next');
      } else {
        return this.getGlobal('Save');
      }
    } else {
      return this.getGlobal('Save');
    }
  }
  backStep() {
    if (this.overlayConfig.data.IsWizardMode === true) {
      if (this.step === 1) {
        this.overlayRef.close({proceed: false});
      } else {
        this.step = 1;
      }
    } else {
      this.overlayRef.close({proceed: false});
    }
  }
  isNextButtonAvailable() {
    if (this.overlayConfig.data.IsWizardMode === true) {
      if (this.step === 1) {
        return this.selectedAudits.length > 1;
      } else {
        if (this.manualMode === true) {
          return this.groupHeader !== null && this.groupHeader !== '';
        } else {
          return this.headerAudit !== null;
        }
      }
    } else {
      if (this.manualMode === true) {
        return this.groupHeader !== null && this.groupHeader !== '';
      } else {
        return this.headerAudit !== null;
      }
    }
  }
}
